export default __webpack_public_path__ + "static/media/time-is-money.cd4e3361.png";